<template>
    <section class="headerContainer">
        <div class="one">
            <div @click="toHomePage"  :class="[shit$(`dis:f; align-i:c; mr:15px;`), shit$(`cursor:p;`)]" v-if="iconLeft.home.showIs">
                <svg-icon :href="'#codelab-home-icon'" :width="32" :height="26"></svg-icon>
            </div>
            <img :class="[shit$(iconLeft.img.shit$)]" :src="iconLeft.img.url" />
            <!-- <svg-icon :href="'#codelab-header-logo-icon'"  :width="105" :height="35"></svg-icon> -->
            <!-- <el-tag :class="shit$(iconLeft.shit$)" v-if="iconLeft.showIs" type="info" effect="dark">{{ iconLeft.label }}</el-tag> -->
        </div>
        <div class="two">
            <div v-if="currentVersion !== 'public' && teams.length > 1" class="groupContainer" :class="[groupPopperShow ? 'groupContainerActive' : '']">
                <el-popover
                    transition="el-zoom-in-top"
                    v-model="groupPopperShow"
                    popper-class="codelab-header-group-popover"
                    placement="bottom"
                    width="200"
                    tabindex="9999"
                    trigger="click">
                    <span slot="reference" class="groupLabel" :class='shit$(`otl:n;`)'>
                        <svg-icon :width="30" :height="30" :href="!groupPopperShow ? '#codelab-header-group-icon' : '#codelab-header-group-icon-active'"></svg-icon>
                        <span class="popoverLabel">{{ currentTeam ? currentTeam.name : $t("code-lab/component/layout/header.vue_0") }}</span>
                        <i :class="[groupPopperShow ? 'groupContainerActive' : '']" class="el-icon-caret-bottom"></i>
                    </span>
                    <div name="content">
                        <p class="groupPopoverUlTitle">{{ $t("code-lab/component/layout/header.vue_0") }}</p>
                        <ul :class="['groupPopoverUl']">
                            <template v-for="(item, index) in teams" >
                                <li @click="switchTeam(item.teamId)" :class="{active: item.teamId === teamId}" :key="index">{{ item.name }}</li>
                            </template>
                            <!-- <p class="line"></p>
                            <li @click="applyTeam">{{ $t("code-lab/component/layout/header.vue_3") }}</li> -->
                        </ul>
                    </div>
                </el-popover>
            </div>
            <div :class="['languageContainer']">
                <el-popover placement="bottom"
                    trigger="click"
                    width="180"
                    popper-class="codelab-header-group-popover"
                    transition="el-zoom-in-top"
                    v-model="language.visible">
                        <span slot="reference" :class="shit$(`active:opacity:.5; dis:f; h:36px; align-i:c; px:10px; hover:bgc:#000000; otl:n;`)">
                            <svg-icon :href="language.visible ? '#codelab-header-language-icon-active' : '#codelab-header-language-icon'" :width="30" :height="30"></svg-icon>
                            <span :class="[shit$(`h:36px; lh:36px; mx:5px; font:14px;`), language.visible && shit$(`c:#00b5e2;`)]">{{ language.label }}</span>
                            <i :class="[language.visible && shit$(`c:#00b5e2!;`)]" class="el-icon-caret-bottom"></i>
                        </span>
                        <div name="content">
                            <language-select @transformMsg="msg => Object.assign(language, msg)"/>
                        </div>
                </el-popover>
            </div>
            <myTool v-if="!['public', 'student'].includes(currentVersion)" style="marginLeft:10px;" />
            <div v-if="currentVersion !== 'public' && userInfo" :class="['userContainer', shit$('cursor:p;')]">
                <el-popover
                    v-model="userInfoPopperVisible"
                    transition="el-zoom-in-top"
                    popper-class="codelab-header-group-popover"
                    placement="bottom"
                    trigger="click">
                    <span slot="reference" class="popoverUser" :class='shit$(`otl:n;`)'>
                        <span :class="shit$(`bgc:rgba(0, 181, 226, .6); hover:bgc:rgba(0, 181, 226, 1)!;`)" class="popoverUserLabel">{{avatarName}}</span>
                    </span>
                    <div name="content">
                        <section class="groupUserInfo">
                            <p class="user-name" v-if="currentVersion === 'student'">{{userInfo.account}} {{userInfo.classId || ""}}</p>
                            <template v-else>
                                <p class="user-name" v-if="userInfo.familyName && userInfo.givenName">{{ userInfo.familyName }}&nbsp;{{ userInfo.givenName}}</p>
                                <p class="user-name" v-else>{{userInfo.name}}</p>
                            </template>
                            <el-tag v-if="currentTeam" type="info" :class="[currentTeam.type]">{{ $t("team." + currentTeam.type) }}</el-tag>
                        </section>
                        <p class="line"></p>
                        <ul class="groupPopoverUl groupUserPopoverUl">
                            <li @click="accountCenter">
                                {{$t(currentVersion === 'student' ? "account.infomation" : "button.account_setting" )}}
                            </li>
                            <p class="line"></p>
                            <li @click="logoutSayBye" >
                                {{ $t("code-lab/component/layout/header.vue_7") }}
                            </li>
                        </ul>
                    </div>
                </el-popover>
            </div>
            <div v-if="currentVersion === 'public'" :class="shit$(`ml:10px;`)">
                <el-button :class="[shit$(`c:#00b5e2!; font:16px; font-w:500; opacity:.9; hover:opacity:1; hover:bgc:#fff; border:none; active:opacity:0.6;`)]"
                @click="() => this[buttons.to.login]()"
                >{{ buttons.login.label }}</el-button>
                <el-button :class="[shit$(`c:#fff!; font:16px; font-w:500; opacity:.9; hover:opacity:1; bgc:#00b5e2!; hover:bgc:#00b5e2; border:none; active:opacity:0.6;`)]"
                @click="() => this[buttons.to.register]()"
                >{{ buttons.register.label }}</el-button>
            </div>
        </div>
        <account-info v-if="currentVersion === 'student' && showAccountInfo" :visible.sync="showAccountInfo"></account-info>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/service/config.js'
import languageSelect from '@/code-lab/component/layout/languageSelect.vue'
import initSocketCicleMix from '@/code-lab/component/mixins/init-socket-cicle-mix.js'
import myTool from '@/code-lab/component/layout/my-tool/my-tool.vue'
import accountInfo from '@/code-lab/component/account-info.vue'
const protocol = window.location.protocol;
const myToolsUrl = protocol + "//" + process.env.VUE_APP_myToolsUrl;
const applyTeamUrl = protocol + "//" + process.env.VUE_APP_applyTeamUrl;
const accountCenterUrl = protocol + "//" + process.env.VUE_APP_accountCenterUrl
const Cookies = window.Cookies;
const cookieDomain = process.env.VUE_APP_cookie_domain;
const scopeKey = process.env.VUE_APP_scopeKey;
export default {
    mixins: [ initSocketCicleMix ],
    components: {
        languageSelect, myTool, accountInfo
    },
    data () {
        return {
            myToolsUrl,
            iconLeft: {
                label: 'Edu',
                img: {
                    url: ""+ process.env.BASE_URL +"static/images/code_lab_public.png",
                    shit$: `w:180px;`,
                },
                showIs: false,
                shit$: '',
                home: { showIs: false, }
            },
            groupPopperShow: false,
            userInfoPopperVisible: false,
            language: {
                label: '',
                visible: false
            },
            buttons: {
                login: { label: this.$t("code-lab/component/layout/header.vue_8") },
                register: { label: this.$t("code-lab/component/layout/header.vue_9") },
                to: { login: 'loginProcess', register: 'registerProcess' }
            },
            showAccountInfo: false
        }
    },
    computed: {
        ...mapState('user', [
            'userInfo',
            'teamId',
            'currentTeam'
        ]),
        ...mapState({
            currentVersion: "currentVersion",
            env$: "env$",
            selectedMenue: "selectedMenue",
            isSaved: "isSaved",
            isAllowSave: "isAllowSave",
            currentMission: "currentMission",
        }),
        currentTeam(){
            if(!this.userInfo){
                return null
            }
            return this.userInfo.currentTeam
        },
        avatarName () {
            if (this.userInfo) {
                let showName = this.userInfo.name || this.userInfo.account || ""
                let names = showName.split(' ')
                if (names.length > 1) {
                    let first = names[0]
                    let last = names[1]
                    const english = /^[A-Za-z0-9]*$/
                    let charA, charB
                    if (english.test(first)) {
                        charA = first.charAt(0).toUpperCase()
                        charB = last.charAt(0).toUpperCase()
                    } else {
                        charA = first
                        charB = ''
                    }
                    showName = charA + charB
                } else {
                    showName = showName.substr(0, 2)
                }
                return showName
            } else {
                return ''
            }
        },
        teams(){
            if(!this.userInfo){
                return []
            }
            return this.userInfo.team.filter(item => {
                return item.scope && item.scope.some(scope => scope.name === scopeKey)
            })
        }
    },
    mounted () {
        this.computedHeaderLayout()
    },
    methods: {
        toHomePage () {
            window.open(this.util$.getNuwaWebsite())
        },
        toProjectList(){
            let oldMenue = this.selectedMenue;
            if(oldMenue === "program"){
                return;
            }
            oldMenue = oldMenue ? oldMenue : (this.currentMission ? "mission" : "program");
            console.log("old Menu", oldMenue ,this.currentMission)
            if (!this.isSaved && this.isAllowSave) {
                let message = 
                    `<div class="tip-icon">
                        <svg width="150" height="150">
                            <use xlink:href="#codelab-project-unsaved"></use>
                        </svg>
                    </div>
                    ${this.$t("message.warn_before_leave_" + oldMenue)}
                `;
                this.$confirm(
                    message, this.$t("popper_title.unsaved_" + oldMenue),
                    {
                        dangerouslyUseHTMLString: true,
                        center: true,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        cancelButtonClass: "codelab-button btn",
                        confirmButtonClass: "codelab-button gray",
                        cancelButtonText: this.$t("button.open_program"),
                        confirmButtonText: this.$t("button.save_before_open"),
                        customClass: "codelab-important-tip project-unsaved",
                    }
                ).catch(() => {
                   this.$store.commit("SELECTEDMENUERIGHT", "program");
                   this.$store.commit("UPDATE_IS_SAVED", true);
                })
            } else {
                this.$store.commit("SELECTEDMENUERIGHT", "program");
                this.$store.commit("UPDATE_IS_SAVED", true);
            }
        },
        loginProcess () {
            this.$router.push({ path: '/guide' })
        },
        registerProcess () {
            const { httpProtocol, httpHost, userCenterUrl } = config
            const lefturl = httpProtocol + '//' + userCenterUrl + '/register?redirect='
            const righturl = httpProtocol + '//' + httpHost + window.location.pathname
            window.location.href = lefturl + righturl
        },
        computedHeaderLayout () {
            const mapping = {
                public: { iconLeft: { showIs: true, home: { showIs: true, }, img: { url: `${this.env$}static/images/code_lab_public.png`, shit$: `w:150px;`,}, }, buttons: { showIs: true, } },
                family: { iconLeft: { showIs: false, home: { showIs: true, }, img: { url: `${this.env$}static/images/code_lab_family.png`, shit$: `w:150px;`,},  }, buttons: { showIs: false, } },
                teacher: { iconLeft: { img: { url: `${this.env$}static/images/code_lab_education.png`, shit$: `w:157px;`,}, home: { showIs: true, } }, buttons: { showIs: false, } },
                student: { iconLeft: { img: { url: `${this.env$}static/images/code_lab_education.png`, shit$: `w:157px;`,}, home: { showIs: false, } }, buttons: { showIs: false, } },
            }
            const target = mapping[this.currentVersion]
            Object.entries(target).forEach(([key, val]) => {
                Object.assign(this[key], val)
            })
        },
        logoutSayBye () {
            this.$confirm(
                this.$t('message.warn_logout'),
                this.$t('popper_title.tips'),
                {
                    confirmButtonText: this.$t('code-lab/component/layout/header.vue_7'),
                    cancelButtonText: this.$t('button.cancel'),
                    type: 'warning',
                    customClass: 'codelab-important-tip',
                    cancelButtonClass: "codelab-button gray",
                    confirmButtonClass: "codelab-button blue"
                }).then(() => {
                const domain = cookieDomain
                console.log("domain:", domain)
                Cookies.remove('token', { domain })
                Cookies.remove('teamId', { domain })
                const { httpProtocol, userCenterUrl } = config
                let redirectUrl = httpProtocol + '//' + userCenterUrl;
                if(this.currentVersion !== "student"){
                    redirectUrl += "/login"
                }
                // redirectUrl += ("?redirect=" + window.location.href.split("?")[0]);
                window.location.href = redirectUrl
            }).catch(() => {})
        },
        switchTeam (teamId) {
            if (this.teamId === teamId) {
                document.body.click()
                return
            }
            this.$confirm(
                this.$t('message.warn_switch_team'),
                this.$t('popper_title.tips'),
                {
                    confirmButtonText: this.$t('code-lab/component/layout/header.vue_0'),
                    cancelButtonText: this.$t('button.cancel'),
                    type: 'warning',
                    customClass: 'codelab-important-tip',
                    cancelButtonClass: "codelab-button gray",
                    confirmButtonClass: "codelab-button blue"
                }).then(() => {
                Cookies.set('teamId', teamId, { path: '/', domain: cookieDomain, expires: 1 })
                window.location.href = window.location.href.replace(this.$route.path, '')
                window.location.reload()
            }).catch(() => {})
        },
        accountCenter () {
            this.userInfoPopperVisible = false;
            if (this.currentVersion === 'student') {
                this.showAccountInfo = true
            } else {
                window.open(accountCenterUrl, '_blank')
            }
        },
        applyTeam(){
            this.groupPopperShow = false;
            window.open(applyTeamUrl, "_blank");
        }
    },
}
</script>

<style lang="scss">
.headerContainer {
    width:100%;
    height: 60px;
    
    background-color: #333333;
    line-height: 60px;
    padding: 0px 30px;
    display: flex;
    justify-content: space-between;
}
.headerContainer > .one {
    display: flex;
    align-items: center;
    
}
.headerContainer > .two {
    display: flex;
    align-items: center;
}

.headerContainer > .one > svg {
    margin-right: 14px;
}
.languageContainer {
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #ffffff;
}

.userContainer {
    color: #ffffff;
    display: flex;
    align-items: center;
    margin-left: 15px;
}
.userContainer > span {
    display: flex;
    height: 100%;
}
.groupContainer {
    display: flex;
    align-items: center;
    color: #ffffff;
}
.groupLabel:hover {
    background-color: #000;
}
.groupLabel:active {
    opacity: .5;
}
.groupLabel {
    display: flex;
    align-items: center;
    padding: 0px 10px;
}
.groupUserInfo {
    padding: 14px 0px 12px 24px;
    color: #ffffff;
}
.groupUserInfo > .el-tag {
    font-size: 12px;
    height: 20px;
    line-height: 18px;
    text-align: center;
    margin-top: 8px;
    border: none;
    &.admin{
        border: solid 1px #333333;
        background-color: rgba(235, 238, 245, 0.5);
        color: #333333;
    }
    &.owner{
        border: solid 1px #00b5e2;
        background-color: rgba(0, 181, 226, 0.1);
        color: #00b5e2;
    }
    &.normal,&.member,&.student{
        border: solid 1px #bbbbc1;
        background-color: rgba(235, 238, 245, 0.1);
        color: #bbbbc1;
    }
}
.groupUserPopoverUl {
    margin-top: 5px;
}
.groupContainerActive {
    color:#00b5e2!important;
}

.headerContainer > .one > .el-tag--dark.el-tag--info {
    background-color: rgba(235, 238, 245, 0.5);
    color: #333333;
    font-size: 12px;
    width: 50px;
    height: 20px;
    line-height: 20px;
    text-align: center;
}

.popoverLabel {
    
    font-size: 14px;
    margin: 0px 5px;
    height: 36px;
    line-height: 36px;
}
.popoverUser{
    display: flex;
    align-items: center;
}
.popoverUserLabel {
    display: block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    
    line-height: 3;
    text-align: center;
    border: 5px solid #6A6A6B;
    font-size: 14px;
    font-weight: 500;
    transition: .3s;
}

.groupPopoverUl > li {
    height: 34px;
    line-height: 34px;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
    padding: 0 12px 0 24px;
}
.groupPopoverUl > li:hover {
    background-color: #000!important;
}
.groupPopoverUl > li:active, .groupPopoverUl > li.active {
    color: #00b5e2!important;
}
.focus {
    color: #00b5e2!important;
}

.userLine {
    margin-top: 5px;
}
.groupPopoverUl li:last-child {
    margin-bottom: 5px;
}
.groupPopoverUlTitle {
    font-size: 12px!important;
    padding-left: 24px;
    margin-top: 20px;
    margin-bottom: 10px;
    color: #ffffff;
}
</style>

<style>
.codelab-header-group-popover {
    background-color: #333333;
    border-color: #000000;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    padding: 0px;
    width: auto!important;
    /* white-space: nowrap; */
}
.codelab-header-group-popover .line {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    
    height: 1px;
    background-color: #282828;
}
.codelab-header-group-popover.el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #000000!important;
}
.codelab-header-group-popover.el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #333333!important;
    border-top-width: 1px;
}

</style>
